import { render, staticRenderFns } from "./comment-dispute-history-client.vue?vue&type=template&id=6cbeb079"
import script from "./comment-dispute-history-client.vue?vue&type=script&lang=js"
export * from "./comment-dispute-history-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports